import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Card, Container, Row, Col, Form, FormLabel, Accordion, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoginManager } from '../../../core/login-manager';
import Select from 'react-select';
import moment from 'moment';
import { toast } from 'react-toastify';



export default function DGTH_mrp({ entity, data, setData, searchObj, setSearchObj }) {

    const [filterActive, setFilterActive] = useState(null);
    const userInfo = LoginManager.getUserInfo();

    function getConto() {
        setFilterActive(true)
        var c = [{ fieldName: "type", type: "different_from_value", value: "0_MATERIA_PRIMA" },
        { fieldName: "supplier_default_id", type: "different_from_value", value: 75 }
        ]
        setSearchObj({
            'query': '',
            'fields': [],
            'constraints': c
        })
    }
    function getMateria() {
        setFilterActive(true)
        var c = [{ fieldName: "type", type: "value", value: "0_MATERIA_PRIMA" }]
        setSearchObj({
            'query': '',
            'fields': [],
            'constraints': c
        })
    }
    function getProduzione() {
        toast.warn("In fase di lavorazione!");
    }
    function removeFilter() {
        setFilterActive(false)
        var c = []
        setSearchObj({
            'query': '',
            'fields': [],
            'constraints': c
        })
    }



    return (
        <>
            <Button className='m-2' variant='primary' onClick={() => { getConto() }}>Filtro Conto Lavoro</Button>
            <Button className='m-2' variant='secondary' onClick={() => { getMateria() }} >Filtro Materia prima</Button>
            <Button className='m-2' variant='warning' onClick={() => { getProduzione() }}>Filtro Produzione interna</Button>
            {filterActive ? <Button className='m-2' variant='outline-danger' onClick={() => { removeFilter() }}><FontAwesomeIcon icon='trash'></FontAwesomeIcon></Button> : null}
        </>
    )
};